import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Transition as _Transition, normalizeStyle as _normalizeStyle, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0707a796"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weissband" }
const _hoisted_2 = { class: "container-wide mx-auto" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-md-6 text-center px-md-5 px-lg-7" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mb-4",
  src: "/assets/images/LOGO_antara_hoch.svg",
  alt: "antara_logo",
  style: {"width":"260px"}
}, null, -1))
const _hoisted_6 = { class: "col-12 col-md-6 text-center px-2 px-md-4 px-lg-5" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, null, -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translate = _resolveComponent("translate")!
  const _component_Button = _resolveComponent("Button")!
  const _component_GreetingCircle = _resolveComponent("GreetingCircle")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#background" }, [
      _createElementVNode("div", {
        class: "min-vh-screen",
        style: _normalizeStyle({
      'background-image': 'url(' + require('../assets/101_titelbild3.jpg') + ')',
      'background-size': 'cover',
      'background-position': 'right'
      })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", {
                  class: _normalizeClass(["delay-1 mb-6", { 'scaleIn': !_ctx.initialized }])
                }, [
                  _createElementVNode("h2", {
                    class: _normalizeClass(["text-primary", { 'h3': _ctx.breakpointUtil.isOnMobile }]),
                    style: {"font-weight":"500"}
                  }, [
                    _createVNode(_component_translate, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Hafen-Grundstücksmanagement")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" & "),
                    _createVNode(_component_translate, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Grundstücksvergabe")
                      ]),
                      _: 1
                    })
                  ], 2),
                  _createElementVNode("h2", {
                    class: _normalizeClass(["text-primary", { 'h3': _ctx.breakpointUtil.isOnMobile }]),
                    style: {"font-weight":"500"}
                  }, [
                    _createVNode(_component_translate, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Innovativ")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" & "),
                    _createVNode(_component_translate, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Intuitiv")
                      ]),
                      _: 1
                    })
                  ], 2)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_Transition, {
                  name: "circle-scale",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_ctx.step1 === 0 && _ctx.rpcClient.state.initialized)
                      ? (_openBlock(), _createBlock(_component_GreetingCircle, {
                          key: 0,
                          class: _normalizeClass(["round", { 'slideInRight': !_ctx.initialized, 'delay-2': !_ctx.initialized }])
                        }, {
                          top: _withCtx(() => [
                            _createVNode(_component_translate, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Eingang für")
                              ]),
                              _: 1
                            })
                          ]),
                          bottom: _withCtx(() => [
                            _hoisted_7
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_Button, {
                              class: _normalizeClass(["p-button-xl w-100 text-center my-2", { 'slideInRight': !_ctx.initialized, 'delay-2': !_ctx.initialized }]),
                              label: _ctx.i18n.$gettext('Kapitäne (Vergabestelle)'),
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/wizard/1')))
                            }, null, 8, ["class", "label"]),
                            _createVNode(_component_Button, {
                              class: _normalizeClass(["p-button-xl w-100 text-center my-2", { 'slideInRight': !_ctx.initialized, 'delay-3': !_ctx.initialized }]),
                              label: _ctx.i18n.$gettext('Passagiere (Bewerber)'),
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/wizard/2'))),
                              onAnimationend: _cache[2] || (_cache[2] = ($event: any) => (_ctx.initialized = true))
                            }, null, 8, ["class", "label"])
                          ]),
                          _: 1
                        }, 8, ["class"]))
                      : (_ctx.step1 === 1)
                        ? (_openBlock(), _createBlock(_component_GreetingCircle, {
                            key: 1,
                            style: {"padding":"1.5rem"}
                          }, {
                            top: _withCtx(() => [
                              (_ctx.rpcClient.session?.user)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                    _createVNode(_component_translate, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Moin")
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.rpcClient.session.user.givenName) + " " + _toDisplayString(_ctx.rpcClient.session.user.surName) + "!", 1),
                                    _hoisted_9
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_translate, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Was möchten Sie tun?")
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_Button, {
                                class: _normalizeClass(["p-button-xl w-100 text-center my-2", { 'slideInRight': !_ctx.initialized }]),
                                label: _ctx.i18n.$gettext('Ausschreibung erstellen'),
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.router.push('/wizard/3')))
                              }, null, 8, ["class", "label"]),
                              _createVNode(_component_Button, {
                                class: _normalizeClass(["p-button-xl w-100 text-center my-2", { 'slideInRight': !_ctx.initialized, 'delay-1': !_ctx.initialized }]),
                                label: _ctx.i18n.$gettext('Ausschreibungen ansehen'),
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.router.push('/projekte')))
                              }, null, 8, ["class", "label"]),
                              _createVNode(_component_Button, {
                                class: _normalizeClass(["p-button-xl w-100 text-center my-2", { 'slideInRight': !_ctx.initialized, 'delay-2': !_ctx.initialized }]),
                                label: _ctx.i18n.$gettext('Grundstücke verwalten'),
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.router.push('/grundstuecke')))
                              }, null, 8, ["class", "label"]),
                              (_ctx.rpcClient.isSystemAdmin)
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 0,
                                    class: _normalizeClass(["p-button-xl w-100 text-center my-2", { 'slideInRight': !_ctx.initialized, 'delay-3': !_ctx.initialized }]),
                                    label: _ctx.i18n.$gettext('System & Konten verwalten'),
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.router.push('/einstellungen')))
                                  }, null, 8, ["class", "label"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : (_ctx.step1 === 2)
                          ? (_openBlock(), _createBlock(_component_GreetingCircle, {
                              key: 2,
                              style: {"padding":"1.5rem"}
                            }, {
                              top: _withCtx(() => [
                                _createVNode(_component_translate, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Was möchten Sie tun?")
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_Button, {
                                  class: "p-button-xl w-100 text-center my-2",
                                  label: _ctx.i18n.$gettext('Einloggen'),
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.rpcClient.nextRoute.afterLogin = Object.assign(this.$route, { path: '/projekte' })))
                                }, null, 8, ["label"]),
                                _createVNode(_component_Button, {
                                  class: "p-button-xl w-100 text-center my-2",
                                  label: _ctx.i18n.$gettext('Öffentliche Ausschreibungen ansehen'),
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.router.push('/projekte')))
                                }, null, 8, ["label"]),
                                _createVNode(_component_Button, {
                                  class: "p-button-xl w-100 text-center my-2",
                                  label: _ctx.i18n.$gettext('Veröffentlichte Grundstücke ansehen'),
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.router.push('/grundstuecke')))
                                }, null, 8, ["label"])
                              ]),
                              _: 1
                            }))
                          : (_ctx.step1 === 3 && !_ctx.step2)
                            ? (_openBlock(), _createBlock(_component_GreetingCircle, {
                                key: 3,
                                style: {"padding":"1.5rem"}
                              }, {
                                top: _withCtx(() => [
                                  _createVNode(_component_translate, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("In welchem Rechtsbereich möchten Sie die Ausschreibung erstellen?")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_Button, {
                                    class: "p-button-xl w-100 text-center my-2",
                                    label: _ctx.i18n.$gettext('Vergaberecht'),
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.router.push('/wizard/3/1')))
                                  }, null, 8, ["label"]),
                                  _createVNode(_component_Button, {
                                    class: "p-button-xl w-100 text-center my-2",
                                    label: _ctx.i18n.$gettext('Kartellrecht'),
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.router.push('/wizard/3/2')))
                                  }, null, 8, ["label"]),
                                  _createVNode(_component_Button, {
                                    class: "p-button-xl w-100 text-center my-2",
                                    label: _ctx.i18n.$gettext('Beihilferecht'),
                                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.router.push('/wizard/3/3')))
                                  }, null, 8, ["label"]),
                                  _createVNode(_component_Button, {
                                    class: "p-button-xl w-100 text-center my-2",
                                    label: _ctx.i18n.$gettext('Eisenbahnrecht'),
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.router.push('/wizard/3/4')))
                                  }, null, 8, ["label"]),
                                  _createVNode(_component_Button, {
                                    class: "p-button-xl w-100 text-center my-2",
                                    label: _ctx.i18n.$gettext('Andere Verfahren'),
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.router.push('/wizard/3/5')))
                                  }, null, 8, ["label"])
                                ]),
                                _: 1
                              }))
                            : (_ctx.step1 === 3 && _ctx.step2 === 1 && !_ctx.step3)
                              ? (_openBlock(), _createBlock(_component_GreetingCircle, {
                                  key: 4,
                                  style: {"padding":"1.5rem"}
                                }, {
                                  top: _withCtx(() => [
                                    _createVNode(_component_translate, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Welcher Rechtsbereich innerhalb des Vergaberechts?")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_Button, {
                                      class: "p-button-xl w-100 text-center my-2",
                                      label: _ctx.i18n.$gettext('Konzessionsrecht'),
                                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.router.push('/wizard/3/1/1')))
                                    }, null, 8, ["label"]),
                                    _createVNode(_component_Button, {
                                      class: "p-button-xl w-100 text-center my-2",
                                      label: _ctx.i18n.$gettext('Anderes Vergaberecht'),
                                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.router.push('/wizard/3/1/2')))
                                    }, null, 8, ["label"])
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.step1 === 3 && _ctx.step2 === 1 && _ctx.step3 === 1)
                                ? (_openBlock(), _createBlock(_component_GreetingCircle, {
                                    key: 5,
                                    style: {"padding":"1.5rem"}
                                  }, {
                                    top: _withCtx(() => [
                                      _createVNode(_component_translate, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Welche Art von Verfahren möchten Sie erstellen?")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_Button, {
                                        class: "p-button-xl w-100 text-center my-2",
                                        label: _ctx.i18n.$gettext('Verhandlungsverfahren'),
                                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.openProjectForm('32014L0023', 0)))
                                      }, null, 8, ["label"]),
                                      _createVNode(_component_Button, {
                                        class: "p-button-xl w-100 text-center my-2",
                                        label: _ctx.i18n.$gettext('Dauerverhandlungsverfahren'),
                                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.openProjectForm('32014L0023', 5)))
                                      }, null, 8, ["label"])
                                    ]),
                                    _: 1
                                  }))
                                : (_ctx.step1 === 3 && _ctx.step2 === 1 && _ctx.step3 === 2)
                                  ? (_openBlock(), _createBlock(_component_GreetingCircle, {
                                      key: 6,
                                      style: {"padding":"1.5rem"}
                                    }, {
                                      top: _withCtx(() => [
                                        _createVNode(_component_translate, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Nach welcher Richtlinie möchten Sie das Verfahren erstellen?")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_Button, {
                                          class: "p-button-xl w-100 text-center my-2",
                                          label: _ctx.i18n.$gettext('Sektorenverordnung (RiLi 2014/25/EU)'),
                                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.openProjectForm('32014L0023', 0)))
                                        }, null, 8, ["label"]),
                                        _createVNode(_component_Button, {
                                          class: "p-button-xl w-100 text-center my-2",
                                          label: _ctx.i18n.$gettext('Vergabeverordnung (RiLi 2014/24/EU)'),
                                          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.openProjectForm('32014L0023', 0)))
                                        }, null, 8, ["label"]),
                                        _createVNode(_component_Button, {
                                          class: "p-button-xl w-100 text-center my-2",
                                          label: _ctx.i18n.$gettext('VOB/A-EU (RiLi 2014/24/EU)'),
                                          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.openProjectForm('32014L0023', 0)))
                                        }, null, 8, ["label"]),
                                        _createVNode(_component_Button, {
                                          class: "p-button-xl w-100 text-center my-2",
                                          label: _ctx.i18n.$gettext('Vergabeverordnung Verteidigung/Sicherheit (RiLi 2009/81/EC)'),
                                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.openProjectForm('32014L0023', 0)))
                                        }, null, 8, ["label"]),
                                        _createVNode(_component_Button, {
                                          class: "p-button-xl w-100 text-center my-2",
                                          label: _ctx.i18n.$gettext('VOB/A (national)'),
                                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.openProjectForm('32014L0023', 0)))
                                        }, null, 8, ["label"]),
                                        _createVNode(_component_Button, {
                                          class: "p-button-xl w-100 text-center my-2",
                                          label: _ctx.i18n.$gettext('UVgO (national)'),
                                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.openProjectForm('32014L0023', 0)))
                                        }, null, 8, ["label"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ], 4)
    ])),
    (_ctx.step1 > 0)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#breadcrumbs"
        }, [
          _createVNode(_component_Breadcrumb, {
            home: { icon: 'pi pi-home', to: '/' },
            model: _ctx.breadcrumbs
          }, null, 8, ["model"])
        ]))
      : _createCommentVNode("", true)
  ]))
}